import { P2GButton } from '@parcel2go/core-ui';

import { PaymentOptionType } from '~/lib/api/smartsend/types';
import ProviderName from '../../../../lib/helpers/ProviderName';
import { ProviderGroupState } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import LocalisedPaymentLink from './LocalisedPaymentLink';

interface props {
  disabled?: boolean;
  manifestable: boolean;
  provider: string;
  state: ProviderGroupState;
  paymentType: PaymentOptionType;
  onClick: () => void;
  reset: () => void;
  close: () => void;
  payLink: string;
  isXs: boolean;
}

export default function PaymentButton(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  if (props.state === 'BOOKING') {
    return (
      <P2GButton disabled size="large">
        {props.paymentType === 'External'
          ? t('GENERATING_PAYMENT_BUTTON', { defaultValue: 'Generating...' })
          : t('BOOKING_PAYMENT_BUTTON', { defaultValue: 'Booking...' })}
      </P2GButton>
    );
  }

  if (props.state === 'BOOKED') {
    return (
      <P2GButton variant="primary" onClick={props.close} size="large">
        {t('CLOSE_PAYMENT_BUTTON', { defaultValue: 'Close' })}
      </P2GButton>
    );
  }

  if (props.state === 'ERROR') {
    return (
      <P2GButton variant="primary" onClick={props.reset} size="large">
        {t('RESET_PAYMENT_BUTTON', { defaultValue: 'Reset' })}
      </P2GButton>
    );
  }

  if (props.state === 'STAGED') {
    return <LocalisedPaymentLink disabled={props.disabled} onClick={props.onClick} payLink={props.payLink} />;
  }

  if (props.paymentType === 'External') {
    // Shares CONTINUE_TO_PAYMENT_BUTTON with LocalisedPaymentLink so the pre- and post-staging
    // buttons read the same, and stays payment-method agnostic under "Other Payment Options".
    return (
      <P2GButton variant="primary" disabled={props.disabled} onClick={props.onClick} size="large">
        {t('CONTINUE_TO_PAYMENT_BUTTON', { defaultValue: 'Continue to Payment' })}
      </P2GButton>
    );
  }

  return (
    <P2GButton variant="primary" disabled={props.disabled} onClick={props.onClick} size="large">
      {props.manifestable
        ? t('GENERATE_LABELS_PAYMENT_BUTTON', { defaultValue: 'Generate Labels' })
        : t('BOOK_PARCELS_PAYMENT_BUTTON', {
            defaultValue: 'Book {{parcel}} Parcels',
            parcel: ProviderName(props.provider)
          })}
    </P2GButton>
  );
}
